import { GetAdvertiesment } from '@/api/data'

const advertisement = {
  state: {
    total: 0,
    rows: [],
    model: {}
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_MODEL: (state, model) => {
      state.model = model
    }
  },
  actions: {
    GetAdvertiesment({ commit }, params) {
      return new Promise((resolve, reject) => {
        GetAdvertiesment(params).then(response => {
          commit('SET_MODEL', response.Data.Model)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default advertisement



// WEBPACK FOOTER //
// ./src/store/modules/advertisement.js